'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapperStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  expanded: _propTypes2.default.bool
};

var defaultProps = {
  expanded: false
};

var expanded = function expanded(_ref) {
  var themeFromProvider = _ref.theme,
      expanded = _ref.expanded;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var styleKey = expanded ? 'expanded' : 'collapsed';

  var _theme$reactackle$com = theme.reactackle.components.accordion.item.expandIcon[styleKey],
      opacity = _theme$reactackle$com.opacity,
      rotateDegree = _theme$reactackle$com.rotateDegree;


  return (0, _styledComponents.css)(['opacity:', ';', ''], opacity, rotateDegree !== null && 'transform: rotate(' + rotateDegree + ');');
};

var size = function size(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com2 = theme.reactackle.components.accordion.item.expandIcon,
      height = _theme$reactackle$com2.height,
      width = _theme$reactackle$com2.width,
      imgHeight = _theme$reactackle$com2.imgHeight,
      imgWidth = _theme$reactackle$com2.imgWidth;


  return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
};

var IconWrapperStyled = exports.IconWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'IconWrapperStyled'
})(['display:flex;align-items:center;', ' ', ' ', ''], expanded, size, (0, _reactackleCore.transition)('opacity, transform'));

IconWrapperStyled.propTypes = propTypes;
IconWrapperStyled.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-accordion/dist/AccordionItem/styles/IconWrapperStyled.js
// module id = 506
// module chunks = 0